/** @format */

export default {
  mounted() {
    this.model = this.value;
  },
  methods: {
    handleChange(model) {
      this.model = model;
      this.vm.evtBus.$emit('B_UPDATE_DATE_BY_DYNAMIC_COMP', {
        where: this.where,
        compDefine: this.compDefine,
        v: model
      });
    }
  },
  data() {
    return {
      model: ''
    };
  },
  props: {
    where: String,
    tpl: String,
    vm: Object,
    compDefine: Object,
    sortDescByLabel: {
      type: Boolean,
      default: false
    },
    detailMode: Boolean,
    label: {
      type: String,
      default: ''
    },
    dict: {
      type: [String, Array, Object],
      default: ''
    },
    value: String,
    httpKey: String,
    handleName: String,
    width: {
      default: 180,
      type: [String, Number]
    }
  }
};
